<template>
  <div class="remove">

      <span class="input-group-addon title" v-if="title">{{title}}</span>
      <div :class="['input-group-btn', 'dropdown', 'd-block', !formEdit && editMode? 'formEdit' : '' ,calWidth != 0 ? ('width-' + calWidth) : '']" ref="dropdown">
        <button type="button" class="btn btn-md line-2 dropdown-toggle" data-toggle="dropdown" :disabled="!formEdit && editMode" :style="{width: !isAuto && calWidth != 0 ? (calWidth+ 'px') : 'auto'}"><div style="text-align:left;display:inline-block;width: calc(100% - 20px);">{{showCheckbox ? checkedDisplayNames : selectedValue}}</div></button>
        <div :class="['dropdown-menu',  'dropdown-menu-scale', inline]" ref="menu"  >
          <ul ref="list" style="max-height: 200px; overflow-y: auto;">
            <li v-for="(item, index) in datasource" :key="index" @mousedown="itemClick(item)" @click="itemClickHanlder()">
              <a v-if="item[itemDisabledField] != null" class="dropdown-item" :class="[item[valueName] == value && isSelectedIcon ? 'selected' : '']" disabled="">
                <label class="md-check" style="margin-right:0" v-if="showCheckbox">
                  <input type="checkbox" v-model="item.checked" @mousedown="itemCheck(item)">
                  <i class="blue"></i>
                </label>
                {{item[displayName]}}</a>

              <a v-if="item[itemDisabledField] == null" class="dropdown-item" :class="[item[valueName] == value && isSelectedIcon ? 'selected' : '']" >
                <label class="md-check" style="margin-right:0" v-if="showCheckbox">
                  <input type="checkbox" v-model="item.checked" @mousedown="itemCheck(item)">
                  <i class="blue"></i>
                </label>
                {{item[displayName]}}</a>
            </li>
          </ul>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  //props: ['value', 'datasource', 'valueName', 'displayName', 'isSelectionFirstData'],
  props: {
    /**
     * 조상에 overflow(auto/hidden)가 걸린 컨테이너 안에서 쓸 때 true.
     * 메뉴를 position:fixed 로 띄워 잘리지 않게 한다.
     * (예: .wp-table-scroll 처럼 가로스크롤이 생기는 표 안의 드롭다운)
     * 기본 false — 기존 사용처 동작은 그대로.
     */
    appendToBody: {
      type: Boolean,
      default: false
    },
    value:{

    },
    inline: {
      type: String,
      default: function() {
        return null;
      }
    },
    width: {
      type: Number,
      default: function() {
        return null;
      }
    },
    title: {
      type: String,
      default: function() {
        return "";
      }
    },
    datasource: {
      type: Array,
      default: function() {
        return [{}];
      }
    },
    showCheckbox: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    isDropup: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    isMultiple: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    valueName: {
      type: String,
      default: function() {
        return "value";
      }
    },
    displayName: {
      type: String,
      default: function() {
        return "name";
      }
    },
    isSelectionFirstData: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    editMode: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    isEdit: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    isFieldMode: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    itemDisabledField: {
      type: String,
      default: function() {
        return "";
      }
    },
    isAuto: {
      type: Boolean,
      default: function(){
        return false;
      }
    },
    isSelectedIcon: {
      type: Boolean,
      default: function(){
        return false;
      }
    }
  },
  computed: {
    calWidth() {
        var result = 0;
        result = this.autoWidth;
        if(this.width)
          result = this.width;
        return result;
    },
    checkedDisplayNames() {
      var that = this;
      if(this.checkedItems)
        return this.checkedItems.map(x=>x[that.displayName]).join(", ");
    }
  },
  data() {
    return {
      checkedItems: '',
      selectedItem: null,
      selectedValue: null,
      selectedIndex: null,
      formEdit: false,
      tempData: null,
      autoWidth: 0,

    };
  },
  mounted() {
    this.$nextTick(function () {
 	 // remove unwanted element all other is work jQuery required
	  	$('.remove').contents().unwrap();

  	})
    this.initComponent(true);
    if (this.appendToBody) this.bindEscapeClip();
  },
  beforeDestroy() {
    if (this.appendToBody) this.unbindEscapeClip();
  },
  watch: {
    value: function(newVal, oldVal){
      if(newVal != oldVal){
        this.initComponent();
        this.$forceUpdate();
      }
    },
    /*
    datasource : function(newVal, oldVal){
      if(newVal != oldVal){
        this.initComponent(true);
      }
    },
    */

    selectedItem: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.datasource.forEach(
          function(item, index) {
            if (item[this.valueName] == newVal[this.valueName]) {

              this.selectedIndex = index;
              this.selectedValue = this.datasource[this.selectedIndex][this.displayName];
              this.$emit("changeValue", {
                evnetName: "changeValue",
                data: this.datasource[this.selectedIndex]
              });
              this.$emit(
                "input",
                this.datasource[this.selectedIndex][this.valueName]
              );
            }
          }.bind(this)
        );
      }
    }
  },
  methods: {
    // ── 조상 overflow 클리핑 회피 (appendToBody=true 일 때만) ──────────────
    // 원인: .wp-table-scroll 같은 래퍼가 overflow-x:auto 를 쓰면 CSS 규칙상
    //       overflow-y 도 auto 로 승격돼, 표 밖으로 나가야 할 메뉴가 잘린다.
    //       화면이 좁아 가로스크롤이 실제로 생길 때만 재현된다.
    // 대응: 열릴 때 메뉴를 position:fixed 로 전환하고 버튼 좌표에 맞춰 띄운다.
    //       fixed 는 컨테이닝 블록이 뷰포트라 조상 overflow 에 잘리지 않는다.
    //       DOM 을 옮기지 않으므로 Vue 렌더링·이벤트 바인딩에 영향이 없다.
    bindEscapeClip() {
      if (typeof $ === 'undefined' || !this.$refs.dropdown) return;
      this.__onShown = () => this.positionFixedMenu();
      this.__onHidden = () => this.resetFixedMenu();
      this.__onReflow = () => { if (this.__clipOpen) this.positionFixedMenu(); };
      $(this.$refs.dropdown).on('shown.bs.dropdown', this.__onShown);
      $(this.$refs.dropdown).on('hidden.bs.dropdown', this.__onHidden);
      window.addEventListener('scroll', this.__onReflow, true);
      window.addEventListener('resize', this.__onReflow);
    },
    unbindEscapeClip() {
      if (typeof $ !== 'undefined' && this.$refs.dropdown) {
        $(this.$refs.dropdown).off('shown.bs.dropdown', this.__onShown);
        $(this.$refs.dropdown).off('hidden.bs.dropdown', this.__onHidden);
      }
      if (this.__onReflow) {
        window.removeEventListener('scroll', this.__onReflow, true);
        window.removeEventListener('resize', this.__onReflow);
      }
    },
    positionFixedMenu() {
      const menu = this.$refs.menu;
      const anchor = this.$refs.dropdown;
      if (!menu || !anchor) return;
      const r = anchor.getBoundingClientRect();
      // 아래 공간이 부족하면 위로 띄운다
      const menuH = menu.offsetHeight || 200;
      const openUp = (window.innerHeight - r.bottom) < menuH && r.top > menuH;
      menu.style.position = 'fixed';
      menu.style.top = (openUp ? Math.max(0, r.top - menuH) : r.bottom) + 'px';
      menu.style.left = r.left + 'px';
      menu.style.minWidth = r.width + 'px';
      menu.style.zIndex = '2000';
      menu.style.display = 'block';
      this.__clipOpen = true;
    },
    resetFixedMenu() {
      const menu = this.$refs.menu;
      if (!menu) return;
      menu.style.position = '';
      menu.style.top = '';
      menu.style.left = '';
      menu.style.minWidth = '';
      menu.style.zIndex = '';
      menu.style.display = '';
      this.__clipOpen = false;
    },

    initComponent(isFirst) {
      this.formEdit = this.isEdit;
      var that = this;

      if(this.autoWidth == 0 || isFirst){
        setTimeout(()=>{
          that.autoWidth =  $(that.$refs.list.parentElement).outerWidth() + 21.83;
        },100)
      }
      if (this.value != null) {
        this.datasource.forEach(
          function(item, index) {
            if(this.itemDisabledField != ""){

              item.disabled = item[this.itemDisabledField];
            }
            if (item[this.valueName] == this.value) {
              this.selectedItem = item;
              return;
            }

            /*
            if(this.autoWidth == 0)
              this.autoWidth =  this.$refs.list.clientWidth
            //가장긴 필드 찾기
            //this.$nextTick(function () {
              /*
              this.$refs.lenField.textContent = item[this.displayName];
              if(this.autoWidth < this.$refs.lenField.clientWidth)
                this.autoWidth  = this.$refs.lenField.clientWidth;
              console.log(item[this.displayName] + this.$refs.lenField.clientWidth)
              */

            //})
          }.bind(this)
        );
      }
      setTimeout(function() {
        if (this.selectedItem == null && this.isSelectionFirstData) {
          this.selectedItem = this.datasource[0];
        }
        this.tempData = Object.assign({}, this.selectedItem);
        if(this.isMultiple){
          this.changeCheckedItems();
        }
      }.bind(this), 300)
    },
    itemClick(item) {

      if(item[this.itemDisabledField]!=undefined) {
        return ;
      }

      this.selectedItem = item;
      setTimeout(
        function() {
          this.formEdit = true;
          this.$emit("close");
          this.$emit("input", item[this.valueName]);
          if(this.isMultiple){
            $(this.$refs.dropdown).addClass('show');
          }
          this.selectedIndex = _.findIndex(this.datasource, x => item[this.valueName] == x[this.valueName])
          this.selectedValue = this.datasource[this.selectedIndex][this.displayName];
        }.bind(this)
      );

      if(this.isMultiple){
        if($(event.target).hasClass('blue'))
          return;
        item.checked = !item.checked;
        this.changeCheckedItems();
      }
    },
    changeCheckedItems(item){
      var that = this;
      var result = [];
      this.datasource.forEach((item)=>{
        if(item.checked)
          result.push(item)
      })
      result.join(",")
      //this.checkedDisplayNames = result.map(x=>x[that.displayName]).join(", ");
      this.checkedItems = result;
      this.$emit('checkBoxChange', result);
    },
    itemClickHanlder(){
      if(this.showCheckbox){
        event.stopImmediatePropagation();
        event.stopPropagation();
      }
    },
    itemCheck(item) {
      var that = this;
      if(this.isMultiple)
        $(this.$refs.dropdown).addClass('show');
      item.checked = !item.checked;
      setTimeout(()=>{
        that.changeCheckedItems();
      },300)
    },
    open() {
      this.$emit("open");
    },
    modeChange(){

      this.formEdit = !this.formEdit;
    },
    confirmInput(event) {
      this.formEdit = false;
      this.$parent.$emit("confirmInput", {childrenCall: true});
      this.$emit("confirmInput");

    },
    cancelInput(event) {

      this.formEdit = false;
      this.selectedItem = Object.assign({}, this.tempData);
      this.$parent.$emit("cancelInput");
    },
  }
};
</script>

<style>
</style>
